import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { useSelector } from 'react-redux';
import { TimespanUnit } from '@debbie/common/dist';
import Input from '../Input';
import Select from '../Select';
const TimingInput = (props) => {
    const lang = useSelector((s) => s.lang);
    const { disabled, timing } = props;
    const [quantity, setQuantity] = useState(timing.details.timespan[0]);
    useEffect(() => {
        if (quantity != timing.details.timespan[0]) {
            setQuantity(timing.details.timespan[0]);
        }
    }, [timing.details.timespan[0]]);
    return (React.createElement("div", null,
        React.createElement("h4", null, lang.workflows.timespan),
        React.createElement(Input, { placeholder: lang.workflows.timespanUnitQuantity, disabled: disabled, type: "number", value: quantity, onChange: (e) => {
                const val = e.target.value;
                setQuantity(val);
                console.log({ val, isNaN: isNaN(parseInt(val)) });
                if (isNaN(parseInt(val))) {
                    return;
                }
                props.onChange(Object.assign(Object.assign({}, timing), { details: Object.assign(Object.assign({}, timing.details), { timespan: [parseInt(val), timing.details.timespan[1]] }) }));
            } }),
        React.createElement(Select, { disabled: disabled, onChange: (e) => props.onChange(Object.assign(Object.assign({}, timing), { details: Object.assign(Object.assign({}, timing.details), { timespan: [
                        timing.details.timespan[0],
                        e.target.value,
                    ] }) })), value: timing.details.timespan[1] }, Object.values(TimespanUnit)
            .filter((unit) => !['ms', 'seconds'].includes(unit))
            .map((unit) => (React.createElement("option", { key: unit, value: unit }, lang.timespanUnits[unit])))),
        React.createElement("h4", null, lang.workflows.timeOfDay),
        React.createElement(DatePicker, { disabled: disabled, selected: timing.details.time
                ? moment().set(timing.details.time).toDate()
                : null, onChange: (date) => {
                props.onChange(Object.assign(Object.assign({}, timing), { details: Object.assign(Object.assign({}, timing.details), { time: date
                            ? {
                                hour: date.getHours(),
                                minute: date.getMinutes(),
                            }
                            : null }) }));
            }, showTimeSelect: true, showTimeSelectOnly: true, timeIntervals: 15, timeCaption: "Time", dateFormat: "HH:mm", timeFormat: "HH:mm" })));
};
export default TimingInput;
//# sourceMappingURL=TimingInput.js.map